import { AddBuisnessPostComponent } from './../../../shared/components/add-buisness-post/add-buisness-post.component';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddAdminPostComponent } from 'src/app/shared/components/add-admin-post/add-admin-post.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { NavigationService } from '../../../providers/navigation.service';

@Component({
  selector: 'sm-business-promotion',
  templateUrl: './business-promotion.component.html',
  styleUrls: ['./business-promotion.component.scss'],
})
export class BusinessPromotionComponent implements OnInit, OnDestroy {
  public buisnessPromoList: any[] = [];
  constructor(
    private _modelRef: MatDialog,
    private _apiService: ApiService,
    private _ngZone: NgZone,
    private _navService: NavigationService,
  ) {
    this._navService.hideSidebarAndNav = false;
  }
  private modelSubscription: Subscription = new Subscription();
  private apiSubscription: Subscription = new Subscription();
  public totalData: number = 0;
  public isLoading: boolean = false;
  public page: number = 1;

  ngOnInit(): void {
    console.log('Hello');
    this.isLoading = true;
    this._apiService.getBuisnessPromotionListCount('1');
    this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
      this.isLoading = true;
      this._apiService.getBuisnessPromotionList(this.page.toString());
    });
    this.apiSubscription = this._apiService.apiResult.subscribe((data) => {
      console.log(data);
      if (
        data.responseType === SM_CONSTANTS.GET_BUISNESS_PROMOTION_LIST_RESULT
      ) {
        if (data.result) {
          this.buisnessPromoList = data.result;
        } else {
          this.buisnessPromoList = [];
        }
      }
      if (
        data.responseType ===
        SM_CONSTANTS.GET_BUISNESS_PROMOTION_LIST_COUNT_RESULT
      ) {
        console.log(data.result);
        if (data.result) {
          this._ngZone.run(() => {
            this.totalData = data.result[0]?.totalRecords;
          });
        }
        this._apiService.getBuisnessPromotionList('1');
      }
      if (
        data.responseType === SM_CONSTANTS.UPDATE_BUISNESS_PROMOTION_INFO_RESULT
      ) {
        this._apiService.getBuisnessPromotionList(this.page.toString());
      }
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    this.modelSubscription.unsubscribe();
    this.apiSubscription.unsubscribe();
  }

  openModel(event: any) {
    this._modelRef.open(AddBuisnessPostComponent, {
      minWidth: '400px',
      data: {
        title: 'Edit business post',
        type: SM_CONSTANTS.BUISNESS_PROMOTION,
        ref: this._modelRef,
        data: event,
      },
    });
  }

  onPageChange(ev: any) {
    this.isLoading = true;
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getBuisnessPromotionList(this.page.toString());
  }

  onCreateNewPost() {
    this._modelRef.open(AddBuisnessPostComponent, {
      minWidth: '400px',
      data: {
        title: 'Add business post',
        type: SM_CONSTANTS.BUISNESS_PROMOTION,
        ref: this._modelRef,
      },
    });
  }
}
